<template>
    <v-flex xs12 text-xs-center>
        <h3  v-show="!showResendCode" class="font-weight-light mt-4">
            Revisa tu correo y sigue las instrucciones para activar tu cuenta
        </h3>

        <v-slide-y-transition>
            <v-flex xs12 v-show="showResendCode">
                <h3 class="font-weight-light" >Tu link de activación ha expirado</h3>
            </v-flex>
        </v-slide-y-transition>

        <v-btn class="mt-4" depressed color="primary" :loading="loading" :disabled="counter !== undefined ? counter > 0 : false" @click="resendCode">
            Enviar nuevo link <span v-if="counter" class="ml-1">({{counter}})</span>
        </v-btn>
    </v-flex>
</template>

<script>

    import {subscribeToPrivateChannelEvents, leaveChannel} from '@/utils/Sockets'
    import {ApiUtils} from '@/utils/ApiUtils'

    import {preventWindowClose} from '@/utils/Common'

    import {mapState, mapMutations} from 'vuex'

    export default{
        props: ['onAccountActivated', 'onActivationCodeSent','onCodeRequestFail', 'counter'],
        mounted(){
            preventWindowClose()
        },
        beforeDestroy(){
            var vm = this
            if(vm.userId){
                leaveChannel(`user.${vm.userId}`)
            }
            preventWindowClose(false)
        },
        data(){
            return {
                loading: false,
                showResendCode: false,
                userId: null
            }
        },
        computed:{
                ...mapState(['currentUser'])
        },
        methods:{
                ...mapMutations(['setCurrentUser']),
            startListening(userId){
                var vm = this
                vm.userId = userId
                subscribeToPrivateChannelEvents(`user.${userId}`, {
                    AccountActivated: vm.onActivationSuccess,
                    ActivationCodeExpired: vm.onActivationCodeExpired
                })
            },
            triggerCodeRequestFail(err){
                if(typeof this.onCodeRequestFail == 'function'){
                    this.onCodeRequestFail(err)
                }
            },
            async resendCode(){

                var vm = this
                vm.loading = true
                const response = await ApiUtils.makeGet('account/code/resend')
                vm.loading = false

                if(!response.ok){
                    const json = await response.json()
                    vm.triggerOnFail(json)
                    return
                }

                if(typeof vm.onActivationCodeSent == 'function'){
                    vm.onActivationCodeSent()
                }
                vm.showResendCode = false

            },

            onActivationSuccess(){
                var vm = this
                let currentUser = vm.currentUser

                if(currentUser && currentUser.id == vm.userId){
                    currentUser.active = 1
                    vm.setCurrentUser(currentUser)
                }

                vm.$nextTick(() => {
                    if(typeof vm.onAccountActivated == 'function'){
                        vm.onAccountActivated()
                    }
                })

            },

            onActivationCodeExpired(){
                var vm = this
                vm.showResendCode = true
            },
        }
    }
</script>